<!--
 * @Author: your name
 * @Date: 2022-03-03 15:38:19
 * @LastEditTime: 2022-05-11 16:08:15
 * @LastEditors: your name
 * @Description: 
 * @ FilePath: Do not edit
 * @par 修改日志:
 * 内容
-->
<template>
  <div class="w-flex-div">
    <div style="padding: 0 10px">
      <piczoom :src="getSrc">
        <img style="width: 100%; min-height: 340px" :src="getSrc" />
      </piczoom>
    </div>
    <div style="padding: 0 10px">
      <div style="padding: 6px 0; background: #f4f4f4" class="u-myflex">
        <span class="u-flex-3">卡口地址：</span>
        <span class="u-flex-9 u-text-l">{{ data.tollgateAddress }}</span>
      </div>
      <div style="padding: 6px 0; background: #f4f4f4" class="u-myflex">
        <span class="u-flex-3">备案情况：</span>
        <span class="u-flex-9 u-text-l">{{ data.status }}</span>
      </div>
      <div style="color: #999">
        <div class="w-flex-div u-a-center" style="padding-top: 20px">
          <div>姓名</div>
          <div>姓别</div>
          <div style="flex: 2">身份证号</div>
        </div>
        <div class="w-flex-div font-bold u-a-center">
          <div>{{ data.fullName }}</div>
          <div>{{ data.sex }}</div>
          <div style="flex: 2">{{ data.identificationNumber }}</div>
        </div>
        <div class="w-flex-div u-a-center" style="padding-top: 20px">
          <div>出生年月</div>
          <div>是否在逃</div>
          <div style="flex: 2">住址</div>
        </div>
        <div class="w-flex-div font-bold u-a-center">
          <div>{{ data.birthday }}</div>
          <div>{{ data.isEscape }}</div>
          <div style="flex: 2">{{ data.address }}</div>
        </div>
      </div>

      <div class="w-flex-div" style="padding-top: 30px">
        <div>
          <el-button
            @click="
              $util.downloadImage(data.imgsrc, `车辆库-${new Date().getTime()}`)
            "
            type="success"
            style="width: 80%"
            >图片下载</el-button
          >
        </div>
        <div>
          <el-button type="success" style="width: 80%">行为轨迹</el-button>
        </div>
      </div>
      <div class="w-flex-div" style="padding-top: 14px">
        <div>
          <el-button type="success" style="width: 80%">以人搜车</el-button>
        </div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import piczoom from '@/components/piczoom.vue';

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    piczoom
  },
  computed: {
    getSrc() {
      return this.data.storageUrl1 || this.data.imgsrc;
    }
  }
};
</script>

<style lang="scss">
.w-flex-div {
  display: flex;

  > div {
    flex: 1;
    text-align: center;
  }
}

.font-bold {
  font-weight: bold;
  padding: 6px 0;
  font-size: 16px;
  color: #403f3f;
}
</style>



// WEBPACK FOOTER //
// src/components/cards-info/driverInfor.vue